export default "__VITE_PUBLIC_ASSET__fe491b7a__"